import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import { useDebounce } from 'usehooks-ts';

import { Spinner } from './Spinner';

export function Lazy(
	props: PropsWithChildren<{
		estimatedHeight?: number;
		spinner?: boolean;
		debounce?: number;
	}>,
) {
	const ref = useRef<HTMLDivElement>(null);
	const [visible, setVisible] = useState(false);
	const debouncedVisible = useDebounce(visible, props.debounce ?? 200);
	const [height, setHeight] = useState(props.estimatedHeight ?? window.innerHeight / 3);

	const isCurrentRef = Boolean(ref.current);

	useEffect(() => {
		if (!ref.current) {
			return;
		}

		const observer = new IntersectionObserver((entries) => {
			const intersecting = entries[0].isIntersecting;
			if (!intersecting) {
				setHeight(entries[0].boundingClientRect.height);
			}
			setVisible(intersecting);
		});
		observer.observe(ref.current);
		return () => observer.disconnect();
	}, [isCurrentRef]);

	return (
		<div ref={ref}>
			{debouncedVisible || props.debounce === 0 ? (
				<Flex>
					<Box flexGrow={1} flexShrink={1}>
						{props.children}
					</Box>
				</Flex>
			) : visible ? (
				props.spinner === false ? (
					<Box style={{ height }} />
				) : (
					<Flex style={{ height }} alignItems="center" justifyContent="center">
						<Spinner />
					</Flex>
				)
			) : (
				<div style={{ height }} />
			)}
			<div style={{ clear: 'both' }} />
		</div>
	);
}
